import React from 'react';
import { PolicyLayout } from '../components/layout/PolicyLayout';
export function TermsConditionsPage() {
  const sections = [{
    id: 'acceptance',
    title: 'Acceptance of Terms',
    content: <>
          <p data-id="element-8464" data-mp="36mvykp126pko">
            By accessing and using Innova Pharmacy's website and services, you
            accept and agree to be bound by these Terms and Conditions. If you
            do not agree to these terms, please do not use our services.
          </p>
          <p className="mt-4" data-id="element-8465" data-mp="2sonvs0hccu1l">
            These terms apply to all visitors, users, and others who access or
            use our services. We reserve the right to modify these terms at any
            time, and your continued use constitutes acceptance of any changes.
          </p>
        </>
  }, {
    id: 'services',
    title: 'Description of Services',
    content: <>
          <p className="mb-4" data-id="element-8466" data-mp="gyda4uo6vwx3">
            Innova Pharmacy provides online pharmaceutical and healthcare
            services, including:
          </p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-8467" data-mp="18ewtmscrwddt">
            <li data-id="element-8468" data-mp="1ci1rghlwrqw4">Sale of prescription and over-the-counter medications</li>
            <li data-id="element-8469" data-mp="yi0i0drkvb51">Health and wellness products</li>
            <li data-id="element-8470" data-mp="yjbsewfj3h54">Prescription verification and fulfillment</li>
            <li data-id="element-8471" data-mp="13glgo8r6lmrd">Pharmacist consultation services</li>
            <li data-id="element-8472" data-mp="13hdbvigv9ih4">Home delivery of medications and products</li>
            <li data-id="element-8473" data-mp="1r6fsqo3of7ak">Health information and resources</li>
          </ul>
          <p className="mt-4" data-id="element-8474" data-mp="1w5sojycizopa">
            All prescription medications require a valid prescription from a
            licensed healthcare provider and are subject to verification by our
            licensed pharmacists.
          </p>
        </>
  }, {
    id: 'account',
    title: 'User Account and Registration',
    content: <>
          <p className="mb-4" data-id="element-8475" data-mp="2a48vnqeavh7y">
            To use certain features of our services, you must create an account.
            You agree to:
          </p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-8476" data-mp="2ossej246degb">
            <li data-id="element-8477" data-mp="2orh9kyyzu0nm">
              Provide accurate, current, and complete information during
              registration
            </li>
            <li data-id="element-8478" data-mp="2ett4bf3rhar7">
              Maintain and update your information to keep it accurate and
              current
            </li>
            <li data-id="element-8479" data-mp="2arg1ozkb9syn">Maintain the security of your password and account</li>
            <li data-id="element-8480" data-mp="25t4smr1ubmhh">Accept responsibility for all activities under your account</li>
            <li data-id="element-8481" data-mp="25v7mxna101s0">
              Notify us immediately of any unauthorized use of your account
            </li>
          </ul>
          <p className="mt-4" data-id="element-8482" data-mp="1w31ygnizg2hk">
            We reserve the right to suspend or terminate accounts that violate
            these terms or engage in fraudulent activity.
          </p>
        </>
  }, {
    id: 'orders',
    title: 'Orders and Payments',
    content: <>
          <p className="mb-4" data-id="element-8483" data-mp="1i3afs9hitxx8">When placing an order through our services:</p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-8484" data-mp="3tr5uex7hssfu">
            <li data-id="element-8485" data-mp="3tqdxnj25sonz">All orders are subject to acceptance and availability</li>
            <li data-id="element-8486" data-mp="2k32u4nqsk53">
              We reserve the right to refuse or cancel any order for any reason
            </li>
            <li data-id="element-8487" data-mp="6nixwwk5ycfo">Prices are subject to change without notice</li>
            <li data-id="element-8488" data-mp="blao9m55tqhr">Payment must be made through our accepted payment methods</li>
            <li data-id="element-8489" data-mp="bj6mb9qtn1k4">
              You are responsible for providing accurate delivery information
            </li>
            <li data-id="element-8490" data-mp="3f29c87bq1z1i">Prescription orders require valid prescription verification</li>
          </ul>
          <p className="mt-4" data-id="element-8491" data-mp="3ezwzq9oqggvu">
            By placing an order, you authorize us to charge your payment method
            for the total amount, including applicable taxes and delivery fees.
          </p>
        </>
  }, {
    id: 'prescriptions',
    title: 'Prescription Requirements',
    content: <>
          <p data-id="element-8492" data-mp="2wb00drehay6r">
            All prescription medications require a valid prescription from a
            licensed healthcare provider. By submitting a prescription, you
            confirm that:
          </p>
          <ul className="list-disc pl-6 space-y-2 mt-4" data-id="element-8493" data-mp="xv0z2yqawf3p">
            <li data-id="element-8494" data-mp="1blcqswiz4bub">The prescription is authentic and has been issued to you</li>
            <li data-id="element-8495" data-mp="1bnh5m9ieuv9d">You have consulted with a healthcare provider</li>
            <li data-id="element-8496" data-mp="16tl97bhspggb">You understand the proper use and potential side effects</li>
            <li data-id="element-8497" data-mp="1lj0xmktut9su">You authorize our pharmacists to verify the prescription</li>
          </ul>
          <p className="mt-4" data-id="element-8498" data-mp="1gkpn07vqiv9k">
            We reserve the right to refuse to fill any prescription that we
            determine to be invalid, fraudulent, or potentially harmful. Our
            pharmacists may contact your healthcare provider for clarification
            if needed.
          </p>
        </>
  }, {
    id: 'intellectual-property',
    title: 'Intellectual Property Rights',
    content: <>
          <p data-id="element-8499" data-mp="3sbkymbolqsfq">
            All content on our website, including text, graphics, logos, images,
            and software, is the property of Innova Pharmacy or its licensors
            and is protected by copyright, trademark, and other intellectual
            property laws.
          </p>
          <p className="mt-4" data-id="element-8500" data-mp="38fgxy092msjf">
            You may not reproduce, distribute, modify, or create derivative
            works from our content without our express written permission.
            Unauthorized use may violate copyright, trademark, and other laws.
          </p>
        </>
  }, {
    id: 'prohibited-uses',
    title: 'Prohibited Uses',
    content: <>
          <p className="mb-4" data-id="element-8501" data-mp="2pipiy30kazl6">You agree not to use our services to:</p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-8502" data-mp="2ufz3p5d0an2o">
            <li data-id="element-8503" data-mp="2ugr18lq5yuvl">Violate any applicable laws or regulations</li>
            <li data-id="element-8504" data-mp="nr2otsldiokh">Submit false or fraudulent prescriptions</li>
            <li data-id="element-8505" data-mp="sp45k6vbubss">Impersonate another person or entity</li>
            <li data-id="element-8506" data-mp="som14myigr9s">Engage in any fraudulent activity</li>
            <li data-id="element-8507" data-mp="qa7i3wwvvuju">Transmit viruses, malware, or harmful code</li>
            <li data-id="element-8508" data-mp="q8cta7ihriah">Attempt to gain unauthorized access to our systems</li>
            <li data-id="element-8509" data-mp="m82p90e9f1y9">Interfere with the proper functioning of our services</li>
            <li data-id="element-8510" data-mp="h999t2fex0vg">Collect or harvest information about other users</li>
          </ul>
        </>
  }, {
    id: 'disclaimer',
    title: 'Disclaimer of Warranties',
    content: <>
          <p data-id="element-8511" data-mp="19yq1fxv7kdqm">
            Our services are provided "as is" and "as available" without any
            warranties of any kind, either express or implied. We do not warrant
            that:
          </p>
          <ul className="list-disc pl-6 space-y-2 mt-4" data-id="element-8512" data-mp="107lk4ri28gsm">
            <li data-id="element-8513" data-mp="v9k289wdeniq">Our services will be uninterrupted or error-free</li>
            <li data-id="element-8514" data-mp="v9aaohvog8ax">
              Results obtained from using our services will be accurate or
              reliable
            </li>
            <li data-id="element-8515" data-mp="1ny7u4obmkb59">Any defects will be corrected</li>
          </ul>
          <p className="mt-4" data-id="element-8516" data-mp="1nwwosk2j6vc1">
            The information provided on our website is for general informational
            purposes only and should not be considered medical advice. Always
            consult with a qualified healthcare provider for medical advice.
          </p>
        </>
  }, {
    id: 'limitation',
    title: 'Limitation of Liability',
    content: <>
          <p data-id="element-8517" data-mp="2a7xz3ka345ja">
            To the maximum extent permitted by law, Innova Pharmacy shall not be
            liable for any indirect, incidental, special, consequential, or
            punitive damages, including loss of profits, data, or other
            intangible losses resulting from:
          </p>
          <ul className="list-disc pl-6 space-y-2 mt-4" data-id="element-8518" data-mp="2o04hld0pmolw">
            <li data-id="element-8519" data-mp="2sw304jzcxcee">Your use or inability to use our services</li>
            <li data-id="element-8520" data-mp="2xw7kil3dyr9w">Unauthorized access to your account or data</li>
            <li data-id="element-8521" data-mp="2xxsb5zmkxq2h">Errors or omissions in our content</li>
            <li data-id="element-8522" data-mp="31xazl5dm0ja2">Any third-party conduct or content</li>
          </ul>
        </>
  }, {
    id: 'governing-law',
    title: 'Governing Law and Dispute Resolution',
    content: <>
          <p data-id="element-8523" data-mp="3j7xloqejvixy">
            These Terms and Conditions are governed by and construed in
            accordance with the laws of the Kingdom of Saudi Arabia. Any
            disputes arising from these terms or your use of our services shall
            be resolved through:
          </p>
          <ul className="list-disc pl-6 space-y-2 mt-4" data-id="element-8524" data-mp="34hqfpa5qbse5">
            <li data-id="element-8525" data-mp="34g6xhe0ij79q">Good faith negotiations between the parties</li>
            <li data-id="element-8526" data-mp="2zk85lgfz774k">Mediation, if negotiations fail</li>
            <li data-id="element-8527" data-mp="3e82vkp2lmxdy">
              Arbitration in Riyadh, Saudi Arabia, if mediation is unsuccessful
            </li>
          </ul>
        </>
  }, {
    id: 'contact-terms',
    title: 'Contact Information',
    content: <>
          <p className="mb-4" data-id="element-8528" data-mp="2lqh2oqwr2lht">
            For questions about these Terms and Conditions, please contact us:
          </p>
          <ul className="list-none space-y-2" data-id="element-8529" data-mp="2gqkz2srysw2s">
            <li data-id="element-8530" data-mp="wa4u7vn8jzw7">
              <strong data-id="element-8531" data-mp="w9lgys8j5zoi">Email:</strong> legal@innovapharmacy.com
            </li>
            <li data-id="element-8532" data-mp="111wlk8e7u9ne">
              <strong data-id="element-8533" data-mp="112emhibtpc1n">Phone:</strong> +966 920 000 000
            </li>
            <li data-id="element-8534" data-mp="na8924021j5w">
              <strong data-id="element-8535" data-mp="narhmu3tev79">Address:</strong> Riyadh, Kingdom of Saudi Arabia
            </li>
          </ul>
        </>
  }];
  return <PolicyLayout title="Terms & Conditions" description="Please read these terms carefully before using our services. By using Innova Pharmacy, you agree to these terms and conditions." lastUpdated="January 15, 2025" sections={sections} seoTitle="Terms & Conditions - Innova Pharmacy" seoDescription="Read Innova Pharmacy's Terms and Conditions governing the use of our online pharmacy services, orders, prescriptions, and user responsibilities." canonical="/terms-conditions" data-id="element-8536" data-mp="rbtfp7lzx17n" />;
}